// TODO:Add Translations to learn-more when the app supports multiple languages.

import i18n from 'i18next';
import config from 'config';
import React from 'react';
import { Image } from 'react-bootstrap';

export function getGotoStageData() {
    return (
        <div>
            <div className="learn-more__heading">GoToStage</div>
            <p>GoToStage.com is the video platform for business content that professionals crave.
            For your business, it’s an opportunity to reach the 60 million professionals who join GoToWebinar events each year.
            It might just become your new favorite way to generate awareness and leads.</p>
            <p>GoToStage gathers organizers content from their Channel pages and makes them more discoverable by viewers.
            This is a one-page hub for on-demand webinars. With GoToStage, you can generate more views and leads by increasing video visibility,
            analyzing audience reports, building relationships and brand awareness, sharing via social accounts, and more.
            Below, learn how you can prep your content and keep track of views your videos gets.</p>
            <p>Unlike YouTube or other platforms, GoToStage prompts viewers to register before watching a video via email, LinkedIn, Facebook or Google.
            Registration information (first and last name, and email) will be available to you via a
                <a href={`${config.broker.g2w.baseURL}/reporting/generateReports.tmpl`} target="_blank"> Recording Report </a>.
            Try how this works by going to
                <a href={`${config.app.baseUrl}`}> GoToStage </a> and opening any of the videos.</p>
            <Image className="learn-more__img" src={`${config.assets.url}/images/learn-more/gotostage.png`} alt="gotostage-img" responsive />
        </div>);
}

export function getAboutChannelData() {
    return (
        <div>
            <div className="learn-more__heading">Your Channel (Beta)</div>
            <p>Your personal Channel page is an easy way to bring your recorded webinars to your audience.
            You can quickly set up a landing page showcasing your best content, customize it to reflect your brand and organize content the way you like.
            A great way to turn your recorded content into ongoing source of new views and new leads!</p>
            <Image className="learn-more__img" src={`${config.assets.url}/images/learn-more/about-channels.png`} alt="channel-img" responsive />
        </div>);
}

export function getHideChannelData() {
    return (
        <div>
            <div className="learn-more__heading">Hide channel (if needed)</div>
            <p>You can opt out of GoToStage if you only want to share your recordings with a select group of people.
            This setting will allow only those viewers with a direct link to your Channel or video to have access to your content.
            Note that all Channels are public by default, unless you change the visibility setting.</p>
            <p><strong>Note:</strong> There is no way to make specific videos on a Channel private.</p>
            <ul>
                <li>Go to the
                    <a href={`${config.broker.g2w.baseURL}/recordings.tmpl`} target="_blank"> My Recordings </a>
                    page or sign in directly from your Channel page with your GoToWebinar, LinkedIn, Facebook or Gmail account.
                </li>
                <li>Select <strong>View Channel Page</strong> to access your Channel.</li>
                <li>Select the Globe icon and <strong>Private</strong> in the drop-down menu.</li>
            </ul>
            <Image className="learn-more__img" src={`${config.assets.url}/images/learn-more/hide-channel.png`} alt="hide-channel-img" responsive />
        </div>);
}

export function getAddRecordingsData() {
    return (
        <div>
            <div className="learn-more__heading">Add recordings to your Channel</div>
            <p>You can add both local and online recordings to your Channel page directly from your My Recordings page.</p>
            <ul>
                <li>Log in to your account at
                    <a href={`${config.broker.g2w.baseURL}`} target="_blank"> global.gotowebinar.com </a> and go to the
                    <a href={`${config.broker.g2w.baseURL}/recordings.tmpl`} target="_blank"> My Recordings </a> page.</li>
                <li>Find the desired recording you would like to prepare and select <strong>Prepare</strong> and then <strong>Continue</strong>.
                Once it is done preparing, you will see a Ready message with a Share link that will launch a Copy link.
                </li>
                <li>Find the desired recording you would like to add to a Channel and toggle the "Add to Channel" button to the On position. </li>
            </ul>
            <Image className="learn-more__img img-boxshadow" src={`${config.assets.url}/images/learn-more/prepare.gif`} alt="img" responsive />
        </div>);
}

export function getAccessChannelData() {
    return (
        <div>
            <div className="learn-more__heading">Access your Channel</div>
            <p>You can easily access your Channel and customize it to your liking! Go to the
                <a href={`${config.broker.g2w.baseURL}/recordings.tmpl`} target="_blank"> My Recordings </a> page and select <strong>View Channel Page</strong> to access your Channel.</p>
            <p>Alternatively, you can go to your Channel page and sign in directly with your GoToWebinar account.</p>
            <Image className="learn-more__img" src={`${config.assets.url}/images/learn-more/access-recordings.png`} alt="img" responsive />
        </div>);
}

export function getCustomizeChannelData() {
    return (
        <div>
            <div className="learn-more__heading">Customize your Channel</div>
            <p>Customize your Channel to your liking with these features:</p>
            <ol>
                <li><strong>Banner image:</strong> Add a banner image at the top of your Channel page.</li>
                <li><strong>Page color theme:</strong> Change the main color theme of your Channel page to match your brand style.</li>
                <li><strong>Name:</strong> Edit the way your Channel name appears.</li>
                <li><strong>Channel logo:</strong> Add a logo to your Channel page, which will appear next to your name.</li>
                <li><strong>Channel description:</strong> Add a description to your Channel page, which will appear under your name. You can add a link to your website there too!</li>
                <li><strong>Featured events:</strong> You can feature up to 5 events, which will be displayed at the top of the Channel page.</li>
                <li><strong>Groups:</strong> Create custom groups to organize your videos on the page.</li>
                <li><strong>Categories:</strong> To make your videos easier discoverable on GoToStage.com and increase the odds of your content featured on the front page -
                add a relevant category to each of your videos.</li>
                <li><strong>Thumbnail pictures:</strong> Videos with great thumbnails are clicked and watched 3x more than other.
                Add a thumbnail which represents your content well!</li>
                <li><strong>Video title and description:</strong> Add a description to each of your videos, so your audience have a good context (and a good reason to watch).
                Good title and description is a key to drive more views from search too!</li>
            </ol>
            <Image className="learn-more__img" src={`${config.assets.url}/images/learn-more/customize-your-Channel.png`} alt="img" responsive />
        </div>);
}

export function getShareChannelData() {
    return (
        <div>
            <div className="learn-more__heading">Share your Channel</div>
            <p>Easily share your Channel page with others by selecting the <strong>Share</strong> button at the top-right of the screen.
            Your unique URL will appear, and then you will be able to copy and paste the link wherever you would like.
            You can also post directly to social media feeds by clicking the corresponding brand icons to open a new pre-populated post.</p>
            <Image className="learn-more__img" src={`${config.assets.url}/images/learn-more/share-your-Channel.png`} alt="share-img" responsive />
        </div>);
}

export function getOptimizeContentData() {
    return (
        <div>
            <div className="learn-more__heading">Optimize your content</div>
            <p>Sprucing up your content can help you increase your chances of having your recording discovered by potential attendees.
            Below we have a few tips for making your content the best it can be so that it catches the eye of users browsing the GoToStage homepage! </p>
            <p>You can make these changes to all videos directly from the Channel page, or from a specific video page. </p>
            <ol>
                <li><strong>Thumbnail pictures:</strong> Use a thumbnail that describes your video well and makes it stand out!
                Add a thumbnail picture to your recordings by selecting the More icon  and then Add thumbnail.
                If you were provided a default thumbnail by GoToWebinar, you can remove it and replace it with a new one.</li>
                <li><strong>Categories:</strong> Categorized videos will appear higher in search results and recommended content.
                Categorize your recording by selecting the More icon and Add Category.
                There are many category options to choose from including Business, Fitness, Marketing, and more.</li>
                <li><strong>Video title:</strong> Use a catchy title. Edit a video title by hovering over the current title and then the Edit icon.</li>
                <li><strong>Video description:</strong> Video descriptions will help them appear higher in search results.
                Add a video description by selecting a specific video and then the "Add a brief description here" field.</li>
            </ol>
            <Image className="learn-more__img" src={`${config.assets.url}/images/learn-more/optimize-your-content.png`} alt="optimize-img" responsive />
        </div>);
}

export function getTrackViewsData() {
    return (
        <div>
            <div className="learn-more__heading">Keep track of views</div>
            <p>You can easily track the number of views for your recordings from the Generate Report section.
            If you&#39;re looking for a detailed report of your viewers, you can generate the Recording Report,
            which will display the registrant&#39;s information and the registration date and time.</p>
            <ol>
                <li>Log in to your account at <a href={`${config.broker.g2w.baseURL}`} target="_blank"> global.gotowebinar.com </a> and select
                    <a href={`${config.broker.g2w.baseURL}/reporting/generateReports.tmpl`} target="_blank"> Generate Reports </a> page.</li>
                <li>Select <strong>Recording Report</strong>, choose a date range of available recordings and select <strong>Show Recordings</strong>.
                    In the "Choose a Recording" table, you will see a <strong>Views</strong> tab with the number of views for each recording.
                You can choose to generate a report for detailed information on the registrants.
                    <br />
                    <strong>Note: </strong> You will only be able to generate reports for recordings from the past year.
                </li>
                <li>Choose the desired recording and format, and select <strong>Generate Report</strong>.</li>
                <li>The report will automatically download to your computer.</li>
            </ol>
            <Image className="learn-more__img" src={`${config.assets.url}/images/learn-more/keep-track-of-views.png`} alt="track-view-img" responsive />
        </div>);
}

export function getAskQuestionsData() {
    return (
        <div>
            <div className="learn-more__heading">Questions & feedback</div>
            <p>Have questions or feedback for the GoToWebinar team? You can easily send those in!</p>
            <ol>
                <li>{i18n.t('learnMore.askQuestions.instruction2a')}
                    <Image className="learn-more__img-inline" src={`${config.assets.url}/images/learn-more/int-widget.png`} alt="" responsive />
                  {i18n.t('learnMore.askQuestions.instruction2b')}
                </li>
                <li>{i18n.t('learnMore.askQuestions.instruction3')}</li>
                <li>{i18n.t('learnMore.askQuestions.instruction4a')}
                    <Image className="learn-more__img-inline" src={`${config.assets.url}/images/learn-more/int-widget-notify.png`} alt="" responsive />
                  {i18n.t('learnMore.askQuestions.instruction4b')}
                </li>
            </ol>
            <Image className="learn-more__img" src={`${config.assets.url}/images/learn-more/questions-and-feedback.png`} alt="img" responsive />
        </div>);
}



// WEBPACK FOOTER //
// ./src/app-lib/helpers/learn-more-helper.js